// extracted by mini-css-extract-plugin
export var instaBlock = "instagram-module--instaBlock--llndD";
export var instaBlockPosts = "instagram-module--instaBlockPosts--S-ETl";